import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Logger } from './logger';

export const isProduction = environment.production;

const noop = (): any => undefined;

@Injectable()
export class ConsoleLoggerService implements Logger {
  get info() {
    if (isProduction) {
      return noop;
    }

    return console.info.bind(console);
  }

  get warn() {
    if (isProduction) {
      return noop;
    }

    return console.warn.bind(console);
  }

  get error() {
    if (isProduction) {
      return noop;
    }

    return console.error.bind(console);
  }

  /**
    * Logs error and sends to log rocket if configured.
    * @param error
    */
  captureError(error: Error): void {
    this.error(error);
  }
}
